module.exports = "/dist/d4e7bf86bbd8e5f43ca73fa831218648.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800.woff2
// module id = 137
// module chunks = 0